import { Link } from 'react-router';
import { DocumentMeta } from '../hooks/useDocumentMeta';

export default function CookiePolicy() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-8" style={{ fontFamily: 'var(--font-secondary)' }}>
      <DocumentMeta title="Politica de Cookies" />
      <h1 className="mb-6 text-3xl font-bold" style={{ color: 'var(--vivid-purple)', fontFamily: 'var(--font-primary)' }}>
        Politica de Cookies
      </h1>
      <p className="mb-4 text-sm text-muted-foreground">Ultima actualizare: 20/03/2026 · Versiunea 1.0</p>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>1. Ce Sunt Cookies?</h2>
        <p>
          Cookies sunt fișiere text de mici dimensiuni stocate pe dispozitivul tău atunci când vizitezi
          un site web. Acestea ajută site-ul să funcționeze corect și să îți ofere o experiență
          personalizată.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>2. Cookies Esențiale</h2>
        <p className="mb-2">
          Aceste cookies sunt necesare pentru funcționarea platformei și nu pot fi dezactivate.
        </p>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="py-2 pr-4 text-left font-semibold">Cookie</th>
                <th className="py-2 pr-4 text-left font-semibold">Scop</th>
                <th className="py-2 text-left font-semibold">Durată</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 pr-4">auth_token (localStorage)</td>
                <td className="py-2 pr-4">Menținerea sesiunii de autentificare</td>
                <td className="py-2">Până la deconectare</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 pr-4">cookie_consent (localStorage)</td>
                <td className="py-2 pr-4">Salvarea preferințelor tale de cookies</td>
                <td className="py-2">1 an</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>3. Cookies de Analytics</h2>
        <p className="mb-2">
          Aceste cookies sunt setate doar dacă îți dai consimțământul. Ne ajută să înțelegem cum
          este utilizată platforma.
        </p>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="py-2 pr-4 text-left font-semibold">Serviciu</th>
                <th className="py-2 pr-4 text-left font-semibold">Cookies</th>
                <th className="py-2 text-left font-semibold">Scop</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 pr-4">Google Analytics (GA4)</td>
                <td className="py-2 pr-4">_ga, _ga_*</td>
                <td className="py-2">Analiza traficului și comportamentului utilizatorilor</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>4. Cookies de Monitorizare Erori</h2>
        <p className="mb-2">
          Aceste cookies sunt setate doar dacă îți dai consimțământul. Ne ajută să identificăm
          și să reparăm erorile din platformă.
        </p>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="py-2 pr-4 text-left font-semibold">Serviciu</th>
                <th className="py-2 text-left font-semibold">Scop</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 pr-4">Sentry</td>
                <td className="py-2">Monitorizarea și raportarea erorilor pentru îmbunătățirea platformei</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>5. Cum Gestionezi Cookies</h2>
        <p className="mb-2">
          Poți gestiona preferințele tale de cookies în mai multe moduri:
        </p>
        <ul className="list-inside list-disc space-y-1">
          <li>Prin banner-ul de cookies afișat la prima vizită</li>
          <li>Din setările browser-ului tău</li>
          <li>Ștergând datele de navigare din browser</li>
        </ul>
        <p className="mt-2">
          Dezactivarea cookies esențiale poate afecta funcționarea platformei.
        </p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>6. Mai Multe Informații</h2>
        <p>
          Pentru detalii despre cum protejăm datele tale, consultă{' '}
          <Link to="/confidentialitate" className="text-[var(--vivid-purple)] underline">Politica de Confidențialitate</Link>.
          Pentru întrebări, contactează-ne la{' '}
          <a href="mailto:contact.ctro@albaiulia2026.ro" className="text-[var(--vivid-purple)] underline">contact.ctro@albaiulia2026.ro</a>.
        </p>
      </section>
    </div>
  );
}
